const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfCompetition extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfCompetition,
            "Each civilization scores 1 culture per level of each of its military units and arena.",
            {}
        )
    }
}

module.exports = ImpactOfCompetition;